module.exports = __webpack_public_path__ + "img/7C.f24d75c3.png";